export const en = {
  approvalAgent: { loading: 'Loading agent…', unknown: 'Unknown agent', deleted: 'Deleted agent' },
  companyActivity: {
    failedAction:
      'A linked tool action failed. The conversation post exists; delivery is not confirmed here.',
    messageAction: 'Message action',
    filters: { all: 'All', messages: 'Messages', tasks: 'Tasks', system: 'System activity' },
    title: 'Activity',
    all: 'All',
    messages: 'Messages',
    tasks: 'Task delegations',
    system: 'System activity',
    filter: 'Filter activity',
    legend:
      'Messages are agent DMs or channel posts. Task delegations hand over work. System activity records tools and platform events.',
    window:
      'Limited view: 8 recent runs (first 1,000 events each) and 8 recent channels (50 latest top-level posts each). Open a conversation for its threads and history.',
    empty: 'No activity in this view for “{{category}}”.',
    partial: 'Some sources could not be loaded; this view is incomplete.',
    unavailable: 'Activity is unavailable. Try again when the source can be loaded.',
    unknownAgent: 'Agent unknown',
    unknownTarget: 'Recipient unknown',
    noPreview: 'No preview in the available metadata.',
    attempt: 'Message action · delivery not confirmed here',
    status: 'Status',
    details: 'Technical details and linked evidence',
    openConversation: 'Open conversation',
    openRun: 'Open run',
    task_delegated: 'Task delegated',
    task_reported: 'Task result reported',
    active: { messages: 'Performing a message action…', tasks: 'Delegating work…' },
    state: {
      completed: 'Completed',
      failed: 'Failed',
      unconfirmed: 'Result not yet available',
      recorded: 'Recorded',
      posted: 'Posted in conversation',
      queued: 'Queued',
      running: 'Running',
      waiting_children: 'Waiting for delegated work',
      awaiting_approval: 'Waiting for approval',
      awaiting_human: 'Waiting for a person',
      scheduled: 'Scheduled',
      cancelled: 'Stopped',
    },
  },
  chatActivity: {
    readingCard: 'Reading a Trello card…',
    searchingCode: 'Searching code…',
    queued: 'Queued',
    running: 'Working…',
    scheduled: 'Waiting for usage limits to reset',
    awaiting_approval: 'Waiting for approval',
    awaiting_human: 'Waiting for your answer',
    waiting_children: 'Waiting for delegated tasks',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Stopped',
    executing: 'Running a command…',
    editing: 'Editing a file…',
    reading: 'Reading information…',
    searching: 'Searching…',
    repository: 'Working with the repository…',
    reviewing: 'Reviewing changes…',
    publishing: 'Publishing changes…',
    checking: 'Checking CI…',
    saving: 'Saving information…',
    delegating: 'Delegating a task…',
    reporting: 'Reporting the result…',
    tool: 'Using a tool…',
    details_one: 'Details · {{count}} step',
    details_other: 'Details · {{count}} steps',
    openRun: 'Open run',
  },
  register: {
    createWithTrial: 'Create account · try 14 days free',
    forgot: 'Forgot password?',
    title: 'Create account',
    checkEmail:
      'Check your e-mail and verify your address. Then choose a subscription. Your trial starts once Stripe has confirmed your checkout.',
    toBilling: 'Continue to subscription',
    name: 'Name',
    email: 'E-mail address',
    password: 'Password (at least 12 characters)',
    terms:
      '14 days free. Add a payment method up front; it then renews automatically. You choose the monthly or yearly price after verifying your e-mail.',
    closed:
      'Public registration is not available yet. Use your invitation or ask an administrator for access.',
    signIn: 'Sign in',
    resetTitle: 'Reset password',
    resetDone: 'Your password has been changed. You can sign in again.',
    resetSent: 'If this account exists, you will receive an e-mail to reset your password.',
    newPassword: 'New password (at least 12 characters)',
    reset: 'Reset',
  },
  support: {
    title: 'Support',
    signingIn: 'Signing in…',
    invalidLink: 'This sign-in link is invalid or expired.',
    banner: 'You are viewing Mandistry as {{name}} for support (read-only, until {{time}}).',
    signOut: 'Stop',
  },
  billing: {
    title: 'Subscription',
    exempt: 'This organization has free access.',
    hasAccess: 'Your subscription gives access.',
    trialUntil: 'Trial until {{date}}.',
    paidUntil: 'Paid access until {{date}}.',
    monthly: 'Monthly subscription',
    yearly: 'Yearly subscription',
    exclVat: '{{price}} excl. VAT',
    korVat: '{{price}} (no VAT charged)',
    loadingPrice: 'loading price',
    choosePlan: 'Choose your plan',
    chooseTitle: 'Choose the plan that fits you',
    chooseSubtitle: '14 days free, cancel any time',
    interval: 'Billing period',
    intervalMonth: 'Monthly',
    intervalYear: 'Yearly',
    yearDealMonths: '{{months}} months free',
    yearDealPercent: 'save {{percent}}%',
    popular: 'Most popular',
    perMonthShort: '/ month',
    billedMonthly: 'billed monthly',
    billedYearly: '{{total}} billed yearly, you save {{saved}}',
    noVat: 'no VAT charged',
    exVat: 'excl. VAT',
    upgrade: 'View plans →',
    setup2fa: 'Set up two-step verification →',
    choose: 'Choose {{plan}}',
    suggested: 'Picked on the website',
    currentPlan: 'Plan: {{plan}}',
    planOrg: '{{companies}} companies · {{agents}} agents · {{seats}} seats',
    planRuns: '{{runs}} runs per month',
    planSandbox: '{{sandbox}} sandbox hours per month',
    blurb: {
      starter: 'For founders putting their first agents to work.',
      team: 'For small teams running real work on agents.',
      business: 'For companies where agents are part of operations.',
    },
    features: {
      tasks: 'Tasks, triggers and cron',
      approvals: 'Approvals, guardrails and budgets',
      memory: 'Memory, knowledge base and skills',
      subscriptions: 'Claude Code and Codex on your own subscription',
      notifications: 'In-app, web push and e-mail notifications',
      everythingStarter: 'Everything in Starter, plus:',
      hireAgents: 'Agents that hire agents',
      gitWorkspaces: 'Git workspaces and pull requests',
      browserFlows: 'Recorded browser flows',
      chatChannels: 'Telegram, Slack and Discord',
      mcp: 'MCP endpoint and access tokens',
      analysis: 'Daily run-error analysis',
      everythingTeam: 'Everything in Team, plus:',
      audit: '3-year audit log',
      priority: 'Priority support',
      onboarding: 'Onboarding session',
    },
    success: {
      title: 'Thank you, and welcome to Mandistry!',
      subtitle: 'Your {{plan}} plan is active. A confirmation is on its way to {{email}}.',
      subtitleTrial:
        'Your {{plan}} trial has started. A confirmation is on its way to {{email}}. Nothing is charged today.',
      receipt: 'Your order',
      plan: 'Plan',
      company: 'Company',
      billedTo: 'Billed to',
      trial: 'Free trial',
      trialValue: '14 days, until {{date}}',
      today: 'Charged today',
      firstPayment: 'First payment',
      firstPaymentValue: '{{amount}} on {{date}}',
      renews: 'Renews',
      renewsValue: 'on {{date}}',
      thenMonth: 'then {{amount}} every month, automatically',
      thenYear: 'then {{amount}} every year, automatically',
      included: 'Included',
      cancelNote: 'Cancel any time before {{date}} and you will not be charged.',
      invoiceNote: 'You will receive an invoice for every payment.',
      nextTitle: "Let's get you set up",
      nextSubtitle: 'Three short steps to your first agent result, about five minutes.',
      steps: {
        provider: { title: 'Connect a model provider', desc: 'Use your own API key or subscription.' },
        agent: { title: 'Create your first agent', desc: 'Start from a template and give it a task.' },
        hello: { title: 'Say hello', desc: 'Chat with it and watch it work.' },
      },
      start: 'Start guided setup',
      skip: 'Skip for now',
      skipHint: 'You can pick this up later from the checklist on Home.',
      confirmingTitle: 'Confirming your payment…',
      confirmingText: 'This usually takes a few seconds. You can leave this page open.',
    },
    unlimited: 'unlimited',
    usagePeriod: 'This period, until {{date}}',
    meter: {
      runs: 'Runs',
      sandbox: 'Sandbox hours',
      agents: 'Agents',
      seats: 'Seats',
      companies: 'Companies',
    },
    managedByOwner: "This company's subscription is managed by the account owner.",
    cancelled: 'Cancelled: your subscription no longer renews. Access continues until the end date.',
    terms:
      '14 days free with your first subscription. You add a payment method up front. It then renews automatically at the chosen price. Cancelling stops the next renewal.',
    finishPayment: 'Finish payment or card verification',
    manage: 'Payment method, invoices and cancellation',
    verificationSent: 'Verification e-mail sent.',
    resendVerification: 'Resend verification e-mail',
    askOwner: 'Ask the owner of this organization to restore the subscription.',
    continue: 'Continue to Mandistry',
    switchOrg: 'Switch organization',
    chooseOrg: 'Choose an organization',
    security: 'Security settings',
    signOut: 'Sign out',
  },
  secure: {
    title: 'Secure your account',
    subtitle:
      'Your account manages billing and your company data, so Mandistry requires two-step verification for owners and admins. It takes about a minute.',
    steps: {
      install: 'Install an authenticator app such as 1Password, Google Authenticator or Authy.',
      scan: 'Scan the QR code and enter the 6-digit code.',
      backup: 'Keep your backup codes somewhere safe.',
    },
    start: 'Set up authenticator app',
    signedInAs: 'Signed in as {{email}}',
    passkey: 'Use a passkey instead',
  },
  composerMode: {
    label: 'Work method',
    inherited: 'Agent default',
    agentDefault: 'agent default',
    plan: 'Plan first',
    planDescription: 'The agent proposes a plan and waits for approval before doing the work.',
    research: 'Web research',
    researchDescription: 'May look up public web pages while working (when the runtime supports it).',
    auto: 'Auto',
    autoDescription:
      'Approves known safe actions without asking. Your rules, required confirmations and access limits still apply.',
    autoLocked: 'Only people who may change this agent can turn on Auto.',
    restore: 'Restore agent defaults',
    close: 'Done',
  },
  permissions: { title: 'Permissions' },
  runControls: {
    plan: {
      planReview: 'Plan review',
      breakingChangesProposed: 'Breaking changes proposed',
      risks: 'Risks',
      validation: 'Validation',
      reviewedBy: 'Reviewed by',
      planFeedback: 'Plan feedback',
      approve: 'Approve',
      requestChanges: 'Request changes',
      reject: 'Reject',
      approvalAppliesToThisVersion:
        'Approval applies to this version. External actions remain subject to execution policy.',
    },
    fields: {
      research: 'Web research',
      planReview: 'Plan review',
      execution: 'Execution',
      agentDefault: 'Agent default',
      off: 'Off',
      on: 'On',
      human: 'Human',
      manager: 'Manager',
      standard: 'Standard',
      auto: 'Auto',
    },
    info: {
      research:
        'Lets the agent research the public web while it works (search where the model supports it, read pages) and keep the sources. Off: it relies on its own knowledge, memory and the tools you gave it.',
      planReview:
        'Before acting, the agent writes a plan. Human: you approve it first. Manager: its manager agent reviews it (advice only, unless Auto is on). Off: it starts right away.',
      execution:
        'Standard: risky actions (external writes, unknown shell commands, money) ask you first. Auto: known, non-destructive actions within its permissions run without asking; destructive ones still ask.',
    },
    research: 'Web research',
    auto: 'Auto execution',
    phases: {
      planning: 'Planning',
      awaiting_review: 'Awaiting review',
      reviewing: 'Reviewing plan',
      executing: 'Executing',
      completed: 'Completed',
    },
  },
  companies: {
    title: 'Companies',
    subtitle: 'Every company is fully isolated: its own agents, keys, budgets, data and sandboxes.',
    all: 'All companies',
    new: 'New company',
    open: 'Open',
    current: 'Current',
    name: 'Name',
    slug: 'Slug',
    slugHint: 'Optional. Lowercase letters, digits and dashes; derived from the name when empty.',
    create: 'Create company',
    createBody:
      'Starts empty: you become its owner and set up providers, models and agents for it. Nothing is copied from other companies.',
    created: '{{name}} created',
    renamed: 'Company updated',
    activeRuns: '{{count}} active',
    pending: '{{count}} pending',
    halted: 'Halted',
    today: 'today',
    none: 'You are not a member of any company yet.',
    onlyAdmins: 'Only a platform admin can create companies.',
    switched: 'Switched to {{name}}',
    delete: 'Delete company',
    deleteBody:
      'Permanently deletes {{name}}: its agents, keys, budgets, chats, runs, memory, skills, sandboxes and workspaces. Running work is cancelled. Work already pushed to af/… branches stays in your repositories; anything not pushed is lost. This cannot be undone.',
    deleteType: 'Type {{slug}} to confirm',
    deleted: '{{name}} deleted',
    deleteLast: 'You cannot delete your only company.',
    thisTab: 'This tab stays in this company; other tabs keep their own.',
  },
  runAnalysis: {
    latest: 'Latest report',
    heroOk: 'All ok in the last 24 hours',
    heroIssues_one: '{{count}} issue needs attention',
    heroIssues_other: '{{count}} issues need attention',
    heroSub: '{{date}} · {{fresh}} new, {{recurring}} recurring, {{resolved}} resolved',
    openReport: 'Open report',
    nextReport: 'Next report',
    off: 'Off',
    act: {
      title: 'Suggested actions',
      hint: 'Nothing runs until you approve it.',
      approve: 'Approve & run',
      approveHere: 'Approve & run suggestion',
      approveAll: 'Approve all ({{count}})',
      done: 'Done',
      confirmTitle_one: 'Run this action?',
      confirmTitle_other: 'Run these {{count}} actions?',
      confirmBody: 'Each step uses your own permissions and is recorded in the audit log.',
      restart_runs_one: 'Restart the failed run of {{subject}} (new run, same input)',
      restart_runs_other: 'Restart {{count}} failed runs of {{subject}} (new runs, same input)',
      cancel_runs_one: 'Stop the stuck run of {{subject}}',
      cancel_runs_other: 'Stop {{count}} stuck runs of {{subject}}',
      enable_trigger: 'Switch trigger “{{name}}” back on',
      success: '{{count}} step(s) completed',
      failed: '{{count}} step(s) failed: {{reason}}',
      open_permissions: 'Review the agent’s permissions',
      open_config: 'Review the agent’s limits',
      open_triggers: 'Open the agent’s triggers',
      openApprovals: 'Open approvals',
    },
    failingStep: 'Failing step',
    unknownStep: 'Unknown',
    kinds: {
      run_failed: 'Failed run',
      run_cancelled: 'Cancelled run',
      run_recovered: 'Recovered run',
      run_stuck: 'Stuck run',
      run_outlier: 'Run outlier',
      tool_error: 'Tool error',
      tool_denied: 'Tool denied',
      tool_slow: 'Slow tool',
      approval: 'Approval',
      trigger_skipped: 'Skipped trigger',
      trigger_disabled: 'Disabled trigger',
      task_failed: 'Failed task',
      flow_failed: 'Failed flow',
    },
    title: 'Run analysis',
    subtitle: 'Daily reports of grouped run errors',
    run: 'Run analysis now',
    enabled: 'Daily analysis enabled',
    time: 'Time',
    save: 'Save settings',
    schedule: 'Schedule',
    allOk: 'All ok',
    empty: 'No reports yet',
    notFound: '404 — Report not found',
    back: 'All reports',
    more: 'Older reports',
    issues: 'Issue groups',
    resolved: 'Resolved',
    'new': 'New',
    recurring: 'Recurring',
    cause: 'Cause hypothesis',
    proposal: 'Proposal',
    category: 'Category',
    first: 'First seen',
    last: 'Last seen',
    count: 'Occurrences',
    examples: 'Example runs',
    analysisCost: 'Analysis cost',
    runCost: 'Run cost',
    model: 'Model',
    tokens: 'Tokens',
    status: 'Analysis status',
    runs: 'Runs',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
    failureRate: 'Failure rate',
    toolCalls: 'Tool calls',
    toolErrors: 'Tool errors',
    approvalsExpired: 'Expired approvals',
    approvalsDenied: 'Denied approvals',
    triggersSkipped: 'Skipped triggers',
    triggersDisabled: 'Disabled triggers',
    tasksFailed: 'Failed tasks',
    issueCount: 'Issue groups',
    newIssues: 'New groups',
    recurringIssues: 'Recurring groups',
    resolvedIssues: 'Resolved groups',
    pendingHint: 'Proposals appear after the next worker tick (up to 10 minutes).',
    twoFactor: 'Set up 2FA in security settings to run analysis or change the schedule.',
    statuses: {
      pending: 'Pending',
      running: 'Running',
      done: 'Done',
      partial: 'Partial',
      not_needed: 'Not needed',
      budget_exceeded: 'Budget exceeded',
      no_model: 'No model',
      failed: 'Failed',
      skipped: 'Skipped',
    },
    categories: {
      agent_instruction: 'Agent instructions',
      tool_policy: 'Tool policy',
      permission_or_integration: 'Permission or integration',
      tool_bug: 'Tool bug',
      workflow: 'Workflow',
      infrastructure: 'Infrastructure',
      other: 'Other',
    },
  },
  nav: {
    runAnalysis: 'Run analysis',
    company: 'Company',
    master: 'Company chat',
    tasks: 'Tasks',
    runs: 'Runs',
    flows: 'Flows',
    skills: 'Skills',
    approvals: 'Approvals',
    usage: 'Usage',
    notifications: 'Notifications',
    settings: 'Settings',
    help: 'Help Center',
    menu: 'Menu',
    main: 'Main navigation',
    home: 'Home',
    workspace: 'Workspace',
    pin: 'Pin {{name}}',
    unpin: 'Unpin {{name}}',
    switch: 'Switch',
    newAgent: 'New agent',
    shortcuts: 'Keyboard shortcuts',
  },
  shell: {
    halted: 'HALTED — all agents are stopped. No new runs will start.',
    resume: 'Resume',
    activeRuns: '{{count}} active',
    spendToday: 'today',
    killSwitch: 'Halt',
    killTitle: 'Halt all agents',
    killBody:
      'This cancels every running job, stops sandboxes and pauses all schedulers for this organization. Type HALT to confirm.',
    killConfirm: 'Halt everything',
    killTypeHalt: 'Type HALT',
    resumeTitle: 'Resume organization',
    resumeBody: 'Agents will accept new runs again. Schedulers resume.',
    userMenu: 'User menu',
    switchOrg: 'Switch organization',
    language: 'Language',
    signOut: 'Sign out',
    commandPalette: 'Command palette',
    twoFaRequired: 'Owners and admins must enable two-factor authentication.',
    twoFaSetup: 'Set up now',
    mockMode: 'MOCK',
    search: 'Search everything…',
    searchLabel: 'Search everything (⌘K)',
    askAgent: 'Ask agent',
    newTask: 'New task',
    inbox: 'Approvals inbox',
    toggleSidebar: 'Toggle sidebar',
    bottomNav: 'Quick navigation',
    more: 'More',
    showPanel: 'Show dashboard panel',
    hidePanel: 'Hide dashboard panel',
    skipToContent: 'Skip to content',
    dismiss: 'Dismiss',
    announcements: 'Announcements',
    haltedCta: 'Review runs',
    priceMissing: 'Price data is missing for some enabled models — costs shown are underestimated.',
    priceMissingCta: 'Set prices',
  },
  palette: {
    placeholder: 'Type a command or search…',
    closePanes: 'Close all open panes',
    empty: 'No results.',
    navigate: 'Navigate',
    agents: 'Agents',
    actions: 'Actions',
    newAgent: 'New agent',
    newTask: 'New task',
    newChat: 'New chat',
    toggleLang: 'Switch language (EN/NL)',
    chatWith: 'Chat with {{name}}',
    dev: 'Mock controls',
    appearance: 'Appearance',
    theme: 'Theme: {{name}}',
    terminalDark: 'Toggle dark terminal panes',
  },
  theme: {
    label: 'Theme',
    system: 'System',
    light: 'Light',
    dark: 'Dark',
    terminalDark: 'Keep terminal panes dark',
  },
  launcher: {
    placeholder: 'Search agents, chats, runs, settings… (> commands, @agent message)',
    filterActions: 'Filter actions…',
    results: 'Results',
    commands: 'Commands',
    askMode: 'Ask an agent',
    sendTo: 'Send to {{name}}',
    askAgent: 'Ask {{name}}…',
    openRuns: 'Open runs of {{name}}',
    openAgent: 'Open {{name}}',
    openRun: 'Open run',
    chat: 'Open chat',
    actionsFor: 'Actions for {{name}}',
    agentFromTemplate: 'New agent from a template',
    resumeAll: 'Resume all agents',
    toggleTheme: 'Toggle light / dark theme',
    switchOrg: 'Switch to {{name}}',
    noAgent: 'No agent matches “@{{handle}}”.',
    typeMessage: 'Type a message after the agent name, then press ⏎.',
    hintMove: 'move',
    hintOpen: 'open',
    hintDrill: 'actions',
    hintCommands: 'commands',
    hintAsk: 'ask agent',
    group: {
      send: 'Send',
      recent: 'Recent',
      setup: 'Getting started',
      navigate: 'Go to',
      agents: 'Agents',
      conversations: 'Conversations',
      runs: 'Runs',
      tasks: 'Tasks',
      approvals: 'Awaiting approval',
      settings: 'Settings',
      actions: 'Actions',
      dev: 'Mock controls',
    },
  },
  shortcuts: {
    spaceNote: '⌘Space belongs to your OS (Spotlight), so the launcher lives on ⌘K / Ctrl+K and /.',
    general: 'General',
    inLauncher: 'In the launcher',
    panes: 'Terminal panes',
    goTo: 'Go to (press g, then the key)',
    launcher: 'Open the launcher',
    launcherSlash: 'Open the launcher (when not typing)',
    ask: 'Ask an agent',
    help: 'Show this overview',
    sidebar: 'Toggle the sidebar',
    panel: 'Toggle the context inspector',
    move: 'Move through results',
    open: 'Open / run',
    secondary: 'Secondary action (e.g. open chat)',
    drill: 'Drill into an agent’s actions',
    commandMode: 'Command mode',
    mention: 'Message an agent: @agent message',
    back: 'Back / close',
    interrupt: 'Interrupt the focused pane’s run',
    modeLine: 'Cycle the approvals mode line',
  },
  providers: {
    checkSubscriptionRequest: 'Subscription request checked',
    checkHybridSubscription: 'Subscription request checked; API key not checked',
    checkHybridLogin: 'API-key model list checked; personal logins not checked',
    outcomeUnknown: 'Unknown — inspect version history',
    apiKeyStored: 'API key stored',
    noApiKeyStored: 'No API key stored (may not be required)',
    authentication: 'Authentication',
    authHybrid: 'Subscription + API key',
    authSubscription: 'Subscription',
    authOwnLogin: 'Personal Claude login · agent creator’s account',
    authChatgpt: 'ChatGPT connection · Codex runtime',
    authToken: 'Setup token · Claude Code runtime',
    statusDisabled: 'Disabled',
    checkLogin: 'Your login checked only; agent creators sign in separately; no model request',
    checkCatalog: 'Account and model list checked; no model execution',
    checkRequest: 'Model list checked; no model execution',
    bulkModel: 'Bulk shortcut',
    bulkApply: 'Fill empty selected targets',
    targetFor: 'New model for {{name}}',
    unchanged: 'Unchanged',
    moveDone: 'Moved · will not be retried',
    moveConflict: 'Agent changed. Reopen this dialog to review current settings.',
    moveUncertain:
      'Outcome unknown: response lost or server error. This agent is locked against retry; inspect its version history before reopening. Other agents can be retried.',
    moveRemaining:
      'Agents still depend on this provider. Select and move all of them before disabling, or explicitly disable without moving.',
    moveSuccess: '{{count}} agent(s) moved',

    saveAndConnect: 'Save & connect ChatGPT',
    moveChangelog: 'Moved from {{from}} to {{to}}',
    moved: '{{count}} agent(s) now use {{model}}',
    movedPartial: '{{count}} moved before the error',
    disableTitle: 'Disable {{name}}?',
    disableBody:
      '{{count}} agent(s) depend on this provider for a primary model or fallback. Disabling it makes those models unavailable. Move primary models and update fallback settings first.',
    moveTitle: 'Move agents away from {{name}}',
    moveBody: '{{count}} agent(s) currently use a model from this provider.',
    fallbackDependency:
      'Some agents depend on this provider only as a fallback. Changing their primary model preserves that fallback. Update their fallback settings first, or explicitly disable without moving; that fallback will become unavailable.',
    disableAnyway: 'Disable without moving',
    moveAndDisable: 'Move agents & disable',
    moveAgents: 'Move agents',
    moveTo: 'New model',
    pickModel: 'Choose a model…',
    noAlternative: 'No other enabled provider with a model is available. Add or enable one first.',
    runtimeNote:
      '{{count}} agent(s) use a runtime that only works with this provider; they switch to the standard AI SDK runtime.',
    undoHint:
      "Each move is a new agent version: restore the old model from the agent's version history at any time.",
    statusNever: 'Not tested yet',
    statusOk: 'Check passed',
    statusFail: 'Failed',
    statusModels: '{{count}} models',
    statusChecked: 'checked {{when}}',
    statusSubscription: 'Subscription verified',
    testNow: 'Test',
    moveAgentsBtn: 'Move agents ({{count}})',
    connectChatgpt: 'ChatGPT subscription',
    connectChatgptHint:
      'Codex agents use your ChatGPT plan instead of an API key. After saving you sign in with a short code.',
    payApi: 'API key',
    payApiHint: 'Pay per token. Works for every runtime.',
    codexPay: 'Codex runtime: how to pay',
    claudePay: 'Claude Code runtime: how to pay',
    claudeLoginHybrid: 'Your Claude account, API key as backup',
    claudeLoginHybridHint:
      "Claude Code runs in each agent's own sandbox on the Claude account of the person who created the agent; when its limit is reached or it is not signed in, the API key takes over.",
    claudeLoginOnly: 'Your Claude account only',
    claudeLoginOnlyHint:
      "Claude Code runs in each agent's own sandbox on its creator's Claude account and waits at its limit. Other runtimes still need an API key.",
    claudeLoginTerms:
      "Usage counts toward your own Claude plan limits and falls under Anthropic's terms. Every person signs in with their own account; agents use their creator's.",
    claudeLoginButton: 'Your Claude account',
    maxCreditsHint:
      'Have Claude Max? It includes $100–200 a month in API credits: create a key in the Claude Console.',
    maxCreditsLink: 'How it works',
    chatgptWaitlist: 'Tell me when it is available',
    chatgptWaitlistJoined: "You're on the list",
    creditBudget: 'Monthly budget (optional)',
    creditBudgetHint:
      "Caps the whole company's spend per month (all providers): a warning at 80%, runs stop at 100%.",
    creditBudgetNone: 'No budget change',
    creditBudgetMax5: '$100 a month (Max 5x credit)',
    creditBudgetMax20: '$200 a month (Max 20x credit)',
    chatgptSoon:
      "ChatGPT subscription: coming soon. Running Codex on a ChatGPT plan in a hosted app needs OpenAI's approval, which we have asked for. Until then Codex uses an API key.",
  },
  claudeLogin: {
    title: 'Your Claude account',
    intro:
      "Claude Code signs in itself, through Anthropic's own page, in a private container. Mandistry never sees your password or token: the login stays with Claude Code in your sandbox.",
    who: 'Your agents (the ones you created) run on this account. Colleagues sign in with their own.',
    start: 'Let Claude Code sign in',
    restart: 'Let Claude Code sign in again',
    starting: 'Starting Claude Code…',
    open: "Open Anthropic's sign-in page",
    paste: 'After signing in, Anthropic shows a code. Paste it here:',
    codeLabel: 'Code from Anthropic',
    send: 'Finish sign-in',
    sent: 'Checking the code…',
    connected: 'Signed in{{who}}',
    plan: 'plan: {{plan}}',
    lastOk: 'last checked {{when}}',
    expired:
      'Anthropic no longer accepts this login. Sign in again; stopped runs can be continued afterwards.',
    failed: 'Signing in did not work ({{code}}). Try again.',
    disconnect: 'Disconnect',
    notUsedYet:
      'Claude Code agents on this provider still pay with an API key. Switch them to this account (the API key, if any, stays as a backup).',
    useForAgents: 'Use this account for Claude Code agents',
    disconnectConfirm: 'Disconnect your Claude account? Your agents stop using it right away.',
    unavailable: 'Signing in with your own Claude account is not enabled on this server.',
    agentsTitle: 'Agents on your account',
    agentsNone: 'None yet. Agents you create run on your account automatically.',
    chosen: 'chosen by you',
    addAgent: 'Also run an agent on my account…',
    add: 'Add',
    removeAgent: "Back to its creator's account",
  },
  guardrails: {
    messagesTitle: 'Messages from colleagues',
    readLateMessages: 'Read messages that arrive just as a run finishes',
    readLateMessagesHint:
      'Normally a message that arrives while the agent is wrapping up is handed to its next run. On: the run continues once more to read it (one extra model turn, so extra cost). Only for AI SDK agents; Claude Code and Codex get messages between their tool calls.',
    respondWhenMentioned: 'Reply to DMs and @mentions while idle',
    respondWhenMentionedHint:
      'On: a DM or @mention from a colleague (or you) starts a short run so the agent replies. Each reply costs a run and tokens; ping-pong between two agents stops by itself. Off: the message waits for the next run.',
  },
  companyPage: {
    openAgent: 'Open agent',
    chat: 'Chat',
    nowWorking: 'Working on now',
    recentRuns: 'Recent runs',
    recentChats: 'Recent chats',
  },
  channels: {
    new: 'New channel',
    newTitle: 'New channel',
    manage: 'Channel settings',
    manageTitle: '#{{slug}} settings',
    manageHint:
      'Members can post with the company_channels tool. Agents that read along get new posts in their context at the start of a run (at most ~300 tokens).',
    slug: 'Channel name (e.g. launch)',
    name: 'Display name',
    topic: 'Topic',
    members: 'Members',
    readsAlong: 'reads along',
    readsAlongFor: '{{name}} reads along',
    tokenNote_one:
      '{{count}} agent reads along: at most ~300 tokens per run, only when there is something new.',
    tokenNote_other:
      '{{count}} agents read along: at most ~300 tokens per run each, only when there is something new.',
    archive: 'Archive channel',
    emptyTitle: 'No channels yet',
    emptyHint:
      'Channels are where your agents talk things over, like Slack. Create one, add agents and give them the company_channels tool. Reading along is optional, so it never burns tokens by surprise.',
    noPosts: 'Nothing said here yet.',
    compose: 'Message #{{slug}} (use @slug to mention an agent)',
    send: 'Send',
    fromRun: 'from a run',
  },
  agentTabs: {
    overview: 'Overview',
    config: 'Config',
    tools: 'Tools & policies',
    triggers: 'Triggers',
    memory: 'Memory',
    runs: 'Runs',
    usage: 'Usage',
  },
  advanced: {
    changed: '{{count}} changed',
    reset: 'Restore defaults',
    basics: 'Basics',
    hintSteps: 'The run stops after this many model steps.',
    hintCost: 'The run stops before it would spend more than this.',
  },
  newAgent: {
    chooseHint: 'Start from a ready-made agent. You can change everything afterwards.',
    blank: 'Start empty',
    blankHint: 'Write your own instructions and pick tools yourself.',
    changeTemplate: 'Other template',
    createAndChat: 'Create & chat',
    basics: 'Basics',
    advanced: 'Advanced options',
    advancedHint:
      'Slug, role, manager, runtime, parameters, guardrails, tools and policies. The defaults are safe.',
    budgetFailed: 'The agent was created, but its daily budget could not be saved.',
    designTitle: 'Describe it — AI builds it',
    designHint:
      'Say what the agent should do. AI picks the best template and writes its profile; you review everything before it is created.',
    designPlaceholder: 'e.g. Answers customer emails about orders and drafts replies for me to approve',
    designButton: 'Design with AI',
    designing: 'Designing…',
    designDone: 'Draft ready · {{cost}}',
    designFrom: 'Drafted by AI from the {{template}} template. Check the instructions before you create it.',
    designUnavailable: {
      no_key: 'AI design is not available right now. Pick a template instead.',
      rate_limited: 'You have used AI design a lot this hour. Try again later or pick a template.',
      budget: "AI design has reached today's limit. Pick a template instead.",
      error: 'AI design did not work this time. Try again or pick a template.',
    },
    orTemplate: 'Or start from a template',
    firstTask: 'Suggested first task',
  },
  setupGate: {
    providerTitle: 'First, connect an AI provider',
    providerWhy:
      'Agents need a model to think with. Connect a provider once; its models are added automatically.',
    providerAsk: 'No AI provider is connected yet. Ask an owner or admin of this company to connect one.',
    modelsTitle: 'Turn on a model first',
    modelsWhy: 'A provider is connected, but none of its models are switched on.',
    modelsAction: 'Choose models →',
    modelsAsk: 'No model is switched on yet. Ask an owner or admin to enable one.',
    agentTitle: 'Create your first agent',
    agentWhy:
      'Chats, tasks and flows are handled by agents. Pick a ready-made one or describe what you need.',
    agentAsk: 'There are no agents yet. Ask an owner or admin to create one.',
  },
  onboarding: {
    title: 'Getting started',
    subtitle: 'Three steps from an empty workspace to your first agent result.',
    progress: '{{done}} of {{total}} done',
    continue: 'Continue setup',
    allDone: 'You are all set',
    hide: 'Hide checklist',
    open: 'Open guided setup',
    next: 'Next step',
    back: 'Back',
    skip: 'Skip for now',
    done: 'Done',
    stepOf: 'Step {{n}} of {{total}}',
    steps: {
      provider: 'Add a provider',
      models: 'Pick default models',
      agent: 'Create your first agent',
      budget: 'Set a budget',
      channels: 'Connect notifications',
      hello: 'Say hello',
    },
    desc: {
      provider: 'Connect Anthropic, OpenAI or another provider. We test the key and sync models with prices.',
      models: 'Choose which synced models agents may use. A cheap model is recommended for background work.',
      agent:
        'Describe what you need and AI builds it, or start from a template. Both come with sensible instructions, guardrails, tools and a budget.',
      budget: 'Cap what the whole organization may spend per day and per month.',
      channels: 'Get approvals and alerts on Telegram or as push notifications.',
      hello: 'Open a chat with your new agent and send a first message.',
    },
    cta: {
      provider: 'Add provider',
      models: 'Pick models',
      agent: 'Choose a template',
      budget: 'Set budget',
      channels: 'Connect',
      hello: 'Open chat',
    },
    addProviderFirst: 'Add a provider first →',
    noModels: 'No models yet — add a provider and its models are synced automatically.',
    apiKey: 'API key',
    baseUrl: 'Base URL',
    connect: 'Connect & sync models',
    signInChatgpt: 'Sign in with ChatGPT',
    connecting: 'Testing the connection…',
    syncing: 'Syncing models and prices…',
    connected: 'Connected · {{count}} models synced',
    testFailed: 'Connection failed: {{error}}',
    keyNote: 'Keys are encrypted at rest and never shown again.',
    apiKeyOptional: 'API key (optional with a subscription)',
    payTitle: 'How your Claude agents are paid',
    payKey: 'API key (recommended for 24/7)',
    payKeyHint:
      'Pay per token, works for every runtime and background work. Have Claude Max? Use its monthly API credits with a Console key.',
    payLogin: 'Your own Claude account',
    payLoginHint:
      "Claude Code agents run in their sandbox on your Claude plan. After saving, Claude Code signs in through Anthropic's page. An API key is optional as a backup.",
    subToken: 'Claude subscription token (optional)',
    subTokenHint:
      'Pro/Max plan: run `claude setup-token` and paste the sk-ant-oat01-… token. Claude Code agents then run on your plan.',
    subDetected: 'That was a Claude subscription token: it has been moved to the subscription field.',
    payMode: {
      api_key: 'Billing: API key (per token).',
      subscription:
        'Billing: Claude subscription only. Agents must use the Claude Code runtime; memory summaries and other background work need an API key.',
      hybrid:
        'Billing: hybrid. Claude Code agents run on your plan and continue on the API key when its limit is reached.',
    },
    recommended: 'Recommended for background work',
    perMillion: '$ in / out per 1M tokens',
    noPrice: 'no price',
    enabledCount: '{{count}} enabled',
    template: 'Template',
    model: 'Model',
    runtime: 'Runtime',
    agentName: 'Name',
    createAgent: 'Create agent',
    budgetIncluded: 'Includes a {{amount}}/day agent budget',
    daily: 'Daily limit (USD)',
    monthly: 'Monthly limit (USD)',
    saveBudget: 'Save budget',
    budgetHint: 'Runs stop before they would exceed a hard limit. You get a warning at 80%.',
    dailyTokens: 'Daily limit (million tokens)',
    monthlyTokens: 'Monthly limit (million tokens)',
    tokenHint:
      "Tokens = input (incl. cached) + output of every model call. Your Claude plan's own usage limits apply as well.",
    budgetBilling: {
      subscription:
        'You pay with a Claude subscription: runs cost $0 per token, so a dollar budget would never fill up. Cap tokens instead, to keep a runaway agent from using up your plan.',
      hybrid:
        'Hybrid: the dollar limits cover API-key usage (fallback and background work); the token limits cover all usage, including the subscription.',
    },
    channelsHint: 'Notification channels live in Settings. Link Telegram or enable push in this browser.',
    openChannels: 'Open notification channels',
    helloAgent: 'Agent',
    helloSend: 'Say hello',
    helloOpen: 'Open chat',
    helloMessage: 'Hi! Briefly introduce yourself and tell me what you can help with.',
    starters: {
      manager1:
        'Draft a plan for launching a newsletter: which agents do we need and what should each do first?',
      manager2: 'Look at which agents we have and tell me which role is missing for a small content team.',
      manager3: 'Summarise what this company can do right now and suggest three useful first tasks.',
      researcher1:
        'Research the three most popular tools for managing AI agents and compare them in a short brief with sources.',
      researcher2: 'Find out what competitors in my market charge and summarise it in a table.',
      researcher3: 'Give me a sourced overview of the latest news on AI agents from the past week.',
      developer1:
        'Set up a small TypeScript project in the sandbox with a test, run it and show me the result.',
      developer2:
        'Write a script that renames all files in a folder to lowercase, test it, and explain how to use it.',
      developer3: 'Check which tools and languages are available in the sandbox and report back.',
      assistant1: 'Write a friendly reply declining a meeting invitation, in three short sentences.',
      assistant2: 'Give me a checklist for preparing a 30-minute client presentation.',
      assistant3: 'Explain what you can do for me and which questions you answer best.',
      writer1:
        'Write a friendly 150-word newsletter intro announcing our new product, with two headline options.',
      writer2: 'Draft a LinkedIn post about what we learned this quarter, in a warm and honest tone.',
      writer3: 'Rewrite this text so it is shorter and clearer: (paste your text here)',
      reviewer1:
        'Review the code in /workspace for bugs and security problems and list the top five findings.',
      reviewer2: 'Check which parts of the project have no tests and suggest what to test first.',
      reviewer3: 'Give me an overview of how this repository is organised and where the risky parts are.',
    },
    optional: 'Optional',
    startNow: 'Create & start',
    firstTask: 'First task',
    firstTaskHint: 'Pick a suggestion or write your own. You will see the result in the chat right away.',
    advanced: 'Advanced options (model, runtime)',
    extrasTitle: 'Fine-tune your workspace',
    extrasSubtitle: 'Your first agent works. These optional steps make it safer and more convenient.',
    started: '{{name}} is working on your task',
    needsAgent: 'Create an agent first.',
    readOnly: 'Your role cannot change this. Ask an owner or admin.',
  },
  ops: {
    title: 'Live operations',
    subtitle: '{{agents}} agents · {{running}} working · {{approval}} awaiting approval',
    list: 'List',
    office: 'Office',
    view: 'View',
    status: {
      running: 'Running',
      approval: 'Awaiting approval',
      idle: 'Idle',
      paused: 'Paused',
      failed: 'Failed',
    },
    noRun: 'No runs yet',
    lastRun: 'Last run {{when}}',
    spendToday: 'today',
    runsToday_one: '{{count}} run today',
    runsToday_other: '{{count}} runs today',
    chat: 'Chat',
    openRun: 'Open run',
    pause: 'Pause {{name}}',
    resume: 'Resume {{name}}',
    approvalBadge_one: '{{count}} approval waiting',
    approvalBadge_other: '{{count}} approvals waiting',
    room: '{{name}}’s team',
    executive: 'Executive',
    empty: 'No agents yet.',
    emptyCta: 'Create your first agent →',
    filter: 'Filter agents',
    liveHint: 'Updates live',
  },
  hoverCard: {
    steps_one: '{{count}} step',
    steps_other: '{{count}} steps',
    openRun: 'View active run',
    openChat: 'Go to the chat',
    newChat: 'Chat',
    activeRun: 'Active run of {{name}}',
  },
  inspector: {
    agentSettings: 'Settings for {{name}}',
    agentSections: 'Agent sections',
    agentUnavailable: 'This agent is unavailable or archived.',
    sections: {
      config: 'Settings · model & instructions',
      permissions: 'Permissions',
      tools: 'Tools',
      mcp: 'Integrations (MCP)',
      triggers: 'Triggers',
      flows: 'Flows',
      skills: 'Skills',
      memory: 'Memory',
      runs: 'Runs',
      usage: 'Usage',
    },
    page: {
      runs: 'Runs right now',
      active: 'Active',
      waitingForYou: 'Waiting for you',
      failedToday: 'Failed (24h)',
      costRunning: 'Cost so far',
      runsBreakdown: '{{running}} running · {{queued}} queued · {{scheduled}} waiting for a limit',
      longest: 'Running the longest',
      nothingActive: 'Nothing is running.',
      lines: 'Active reporting lines',
      noLines: 'No agent is handing work to another right now.',
      approvals: 'Waiting for a decision',
      nothingWaiting: 'Nothing is waiting for you.',
      pending: 'Pending',
      soonest: 'Expires in',
      byAgent: 'By agent',
      byTool: 'By action',
      tasks: 'Task queue',
      open: 'Open',
      overdue: 'Overdue',
      tasksBreakdown: '{{running}} in progress · {{queued}} queued',
    },
    label: 'Context inspector',
    scope: 'Show context for',
    organization: 'Organization',
    focused: 'focused',
    collapse: 'Collapse inspector',
    noAgents: 'No agents yet. Create one to see live status, spend and runs here.',
    noRuns: 'No runs yet.',
    sayHello: 'Say hello to an agent →',
    createAgent: 'Create your first agent →',
    addProvider: 'Add a provider first →',
    agentPaused: 'Paused — it does not start new work.',
    lastActive: 'Idle · last active {{when}}',
    toolAccess: 'Tool access',
    cost14d: 'Cost · last 14 days',
    responseTime: 'Typical run time',
    success: 'succeeded',
    idle_one: '{{count}} agent idle',
    idle_other: '{{count}} agents idle',
    hero: {
      working_one: '{{count}} agent working',
      working_other: '{{count}} agents working',
      waiting_one: '{{count}} waiting for you',
      waiting_other: '{{count}} waiting for you',
      halted: 'All agents are halted',
      sub_one: '{{count}} agent · {{spent}} spent today',
      sub_other: '{{count}} agents · {{spent}} spent today',
    },
    act: {
      working: 'Working…',
      thinking: 'Thinking…',
      writing: 'Writing a reply…',
      tool: 'Using {{tool}}',
      delegating: 'Handing work to {{role}}',
      approval: 'Waiting for your approval',
      question: 'Asked you a question',
      waitingChildren: 'Waiting for its helpers to finish',
      waitingOn: 'Waiting for {{names}}',
      queued: 'Queued, starts soon',
      scheduled: 'Paused until a limit resets',
    },
    needs: {
      title_one: 'Needs you ({{count}})',
      title_other: 'Needs you ({{count}})',
      approval: 'wants to: {{tool}}',
      question: 'asks you something',
      waiting: 'waits for an approval',
      review: 'Review',
      answer: 'Answer',
      inbox: 'Approvals inbox',
    },
    working: {
      title: 'Working now',
      none: 'Nobody is working right now.',
    },
    today: {
      spent: 'Spent today',
      ofBudget: '{{pct}}% of daily budget',
      noBudget: 'no daily budget',
      done: 'Finished today',
      doneSub: 'runs completed',
      failed: 'Failed today',
      failedSub: 'see recent below',
      allGood: 'all good',
    },
    recent: {
      title: 'Recently finished',
      all: 'All runs',
      done: 'finished {{what}}',
      failed: 'failed {{what}}',
      stopped: 'stopped {{what}}',
    },
    mode: { chat: 'a chat reply', task: 'a task', subagent: 'a sub-task' },
  },
  chats: {
    masterNoModel: 'Commands like /status work now; questions need an AI model.',
    masterConnect: 'Connect a provider →',
    title: 'Chats',
    new: 'New chat',
    all: 'All chats',
    company: 'Company chat',
    companyHint: 'Ask anything — it routes work to your agents',
    companyShort: 'The whole company at once',
    search: 'Search chats…',
    none: 'No chats yet. Start one with “New chat”.',
    noMatch: 'No chats match.',
    waitingSubscription: '{{name}} is waiting for the subscription limit',
    working: '{{name}} is working…',
    waitingForYou: 'Waiting for you',
    newReply: 'New reply',
    unknownAgent: 'Agent',
    openSideBySide: 'Open next to the current chat',
    openCount_one: '{{count}} chat open',
    openCount_other: '{{count}} chats open',
    closeAll: 'Close all',
    bucket: { today: 'Today', yesterday: 'Yesterday', week: 'Previous 7 days', older: 'Older' },
    startTitle: 'Who do you want to talk to?',
    startHint:
      'Pick an agent (or the whole company) and write your message. Paste or drop a screenshot to show what you mean.',
    pickAgent: 'Pick an agent',
    showAll: 'Show all {{count}} agents',
    showFewer: 'Show fewer',
    messageTo: 'Message to {{name}}',
    placeholder: 'Message {{name}}…',
    paused: '{{name}} is paused',
    recentWith: 'Recent chats with {{name}}',
    noAgents: 'You have no agents yet.',
    createAgent: 'Create one →',
  },
  home: {
    placeholder: 'Ask {{name}} to plan the launch…',
    placeholderNone: 'Create an agent to get started…',
    composer: 'Message for {{name}}',
    send: 'Send to {{name}}',
    pickAgent: 'Agent: {{name}}. Choose another agent',
    starters: 'Insert a starter prompt',
    starter1: 'Plan the product launch for next month and delegate the work to the team.',
    starter2: 'Summarize what every agent did today and flag anything blocked.',
    starter3: 'Research our three main competitors and compare their pricing.',
    runtime: 'Model and runtime',
    readOnly: 'Your role cannot start chats.',
    halted: 'Agents are halted — resume them to send.',
    sending: 'Starting chat…',
    quickActions: 'Quick actions',
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    status: '{{agents}} agents active · {{running}} runs running',
    composerTitle: 'New assignment',
    to: 'To',
    sendLabel: 'Send',
    quickActionsHint: 'Common places',
    actNewAgent: 'New agent',
    actNewAgentDesc: 'Set up an agent with a role, tools and limits',
    actTask: 'Create task',
    actTaskDesc: 'Give an agent a goal with its own plan',
    actTrigger: 'Set up a trigger',
    actTriggerDesc: 'Start an agent on a schedule or event',
    actMcp: 'MCP connections',
    actMcpDesc: 'Connect external tools and tokens',
    actMore: 'Search everything',
    actMoreDesc: 'Open search for any page or action',
  },
  skills: {
    title: 'Skills',
    subtitle:
      'Reusable instruction bundles (open Agent Skills format). Agents see a one-line catalog and load a skill only when it matches the task.',
    agentTab: 'Skills',
    agentHint:
      'Bound skills appear in this agent’s catalog. Saved as a new agent version. Only live skills can be bound.',
    agentNone: 'No live skills yet. Create or import one on the Skills page.',
    noSandboxHint:
      'Skill scripts can only run when this agent has the sandbox tools enabled (Tools & Policies).',
    new: 'New skill',
    newTitle: 'New skill',
    editTitle: 'Edit {{name}}',
    editHint:
      'SKILL.md in the open Agent Skills format. Saving makes the new version live for every agent bound to it.',
    import: 'Import zip',
    imported: 'Imported {{name}}',
    export: 'Export zip',
    archive: 'Archive',
    archiveTitle: 'Archive {{name}}?',
    archiveHint: 'Agents stop seeing this skill. Its history is kept.',
    archivedHint: 'This skill is archived and invisible to agents.',
    draftHint: 'This skill is a draft: it has never been live.',
    none: 'No skills yet.',
    archived: 'Archived',
    review: 'Needs review',
    reviewBanner_one:
      '{{count}} agent-written skill change waits for your review. Nothing is used by agents until you activate it.',
    reviewBanner_other:
      '{{count}} agent-written skill changes wait for your review. Nothing is used by agents until you activate it.',
    untrustedHint:
      'This proposal was written by an agent that processes untrusted input (web pages, emails, webhooks). Read it carefully before activating: it could contain instructions planted by someone else.',
    needsReview: 'Needs review',
    proposal: 'Proposed version {{version}}',
    proposalHint: 'Written by an agent. It is not used by any agent until you activate it.',
    activate: 'Activate',
    activated: 'Skill version is live',
    reject: 'Reject',
    rejected: 'Proposal rejected',
    source: 'Source',
    sources: { manual: 'Manual', import: 'Imported', agent: 'Agent' },
    status: { draft: 'Draft', active: 'Active', archived: 'Archived' },
    versionState: { active: 'Live / past', proposed: 'Proposed', rejected: 'Rejected' },
    live: 'live',
    attachedTo: 'Used by',
    notAttached: 'Not bound to any agent yet.',
    usage: {
      line: 'Offered {{exposures}}× · loaded {{loads}}× in {{days}} days',
      rate: '{{pct}}% load rate',
      tokens: '~{{tokens}} tokens per run',
      lastLoaded: 'last loaded {{when}}',
      title:
        'Runs that saw the skill in their catalog vs. runs that loaded it. Every offered run pays the catalog tokens.',
      unused: 'Not loaded in {{days}} days',
      unusedHint:
        'Offered to runs but never loaded: it costs catalog tokens for nothing. Consider archiving it.',
    },
    updated: 'Updated',
    versions: 'Versions',
    changelog: 'Changelog',
    files: 'Files',
    noFiles: 'No extra files.',
    addFile: 'File',
    filePath: 'File path',
    fileContent: 'File content',
    filesHint: 'Text files only (scripts/, references/, …), up to 1 MB each.',
    editor: {
      guided: 'Guided',
      preview: 'Preview',
      source: 'SKILL.md',
      name: 'Name',
      nameHint: 'Lowercase letters, digits and hyphens. This is what the agent loads the skill by.',
      nameLocked: 'A live skill keeps its name across versions.',
      description: 'When should an agent use it?',
      descHint:
        'One or two sentences: what it does and when to use it. Agents only see this line until they load the skill.',
      descPlaceholder:
        'Build the weekly sales report and post it to the team channel. Use when asked for last week’s numbers.',
      instructions: 'Instructions',
      instructionsHint:
        'Build it from steps, notes and code. Write <placeholders> for values that change per task.',
      noBlocks: 'No instructions yet — add a list of steps to begin.',
      blocks: { heading: 'Section', steps: 'Steps', bullets: 'List', text: 'Note', code: 'Code' },
      addSteps: 'Steps',
      addBullets: 'List',
      addSection: 'Section',
      addNote: 'Note',
      addCode: 'Code',
      addStep: 'Add step',
      addBullet: 'Add item',
      step: 'Step {{n}}',
      bullet: 'Item {{n}}',
      stepPlaceholder: 'Describe what to do… (Enter adds the next step)',
      bulletPlaceholder: 'Describe the item…',
      headingPlaceholder: 'Section title',
      textPlaceholder: 'Write a note or some background…',
      language: 'Language',
      level: 'Heading level',
      moveUp: 'Move up',
      moveDown: 'Move down',
      remove: 'Remove',
      removeBlock: 'Remove block',
      inputs: 'Inputs this skill expects',
      inputsHint: 'Values in <angle brackets> are filled in by the agent for each task.',
      tools: 'Tools it uses (optional)',
      toolsHint: 'Advisory only: it never grants a tool. Tool policy decides what an agent may do.',
      toolsPlaceholder: 'Add a tool + Enter',
      removeTool: 'Remove {{tool}}',
      addScript: 'Script',
      addReference: 'Reference',
      previewCatalog: 'What the catalog shows an agent',
      previewEmpty: 'Nothing to preview yet.',
      sourceHint: 'The raw SKILL.md. Changes here and in the guided view stay in sync.',
      sourceInvalid: 'SKILL.md needs a --- frontmatter block at the top. Your last valid version is kept.',
      errors: {
        name: {
          required: 'Give the skill a name.',
          format: 'Use lowercase letters, digits and single hyphens (max 64).',
        },
        description: {
          required: 'Say when an agent should use this skill.',
          long: 'Keep the description under 1024 characters.',
        },
        body: { required: 'Add at least one step or note.' },
      },
    },
    suggestions: {
      title: 'Suggested skills',
      subtitle: 'Learned from repeated work. Nothing is used by an agent until you add it.',
      kind: { new: 'New', update: 'Change' },
      auto: 'Learned automatically',
      untrusted: 'Untrusted input',
      learned: '{{agent}} did this {{count}} times in a row.',
      proposedBy: 'Proposed by {{agent}}.',
      showSteps: 'Show the steps',
      showChanges: 'Show what changes',
      add: 'Add skill',
      editAdd: 'Edit & add',
      dismiss: 'Dismiss',
      added: 'Skill added',
      dismissed: 'Suggestion dismissed',
      giveTo: 'Also give to {{agent}}',
      attachFailed: 'Skill added, but could not be given to the agent: {{error}}',
      reviewTitle: 'Review {{name}}',
      reviewHint: 'Change anything you like. Adding makes it live for the agents it is bound to.',
    },
  },
  flows: {
    title: 'Flows',
    subtitle:
      'Record a procedure once — agents repeat it with your integrations (MCP), without a model where possible.',
    record: 'Record',
    recordTitle: 'Record a procedure',
    recordHint:
      'Perform the procedure in Chrome with the Mandistry recorder. When you stop, every step is mapped onto your integrations (MCP); clicking in a browser is only the last resort.',
    name: 'What are you recording?',
    namePlaceholder: 'e.g. File a bug in Linear',
    targetAgent: 'For agent (optional)',
    anyAgent: 'Decide later',
    includeValues:
      'Record typed values as defaults (passwords, card numbers and one-time codes are never recorded)',
    start: 'Start recording',
    extConnected: 'Recorder extension connected',
    extNotPaired: 'Recorder extension found, not connected to this server yet',
    extMissing: 'Recorder extension not detected',
    extInstall: 'Install the Chrome extension once (about a minute); this page notices it by itself.',
    extDownload: 'Download extension (.zip)',
    extStep1: 'Download the zip and unzip it (you get a folder called mandistry-recorder).',
    extStep2: 'Open {{url}} in Chrome and switch on Developer mode (top right).',
    extStep3: 'Click Load unpacked and choose the mandistry-recorder folder.',
    extStep4: 'The extension settings open: enter {{origin}} and click Allow & save.',
    extStep5: 'Come back to this page and click Connect extension.',
    extCopy: 'Copy',
    extCopied: 'Copied',
    extHelp: 'Step-by-step guide',
    extConnect: 'Connect extension',
    extPaired: 'Extension connected',
    recordings: 'Recordings',
    noRecordings: 'No recordings yet.',
    noFlows: 'No flows yet — record a procedure to create one.',
    status: {
      recording: 'recording',
      stopped: 'stopped',
      synthesizing: 'building flow',
      ready: 'ready',
      failed: 'failed',
      draft: 'draft',
      active: 'active',
      archived: 'archived',
    },
    events: '{{count}} events',
    stop: 'Stop & build flow',
    waiting: 'Waiting for events from the extension… perform the procedure in another tab.',
    building: 'Building the flow: mapping your steps onto integrations…',
    openFlow: 'Open flow',
    rebuild: 'Build again',
    steps: 'Steps',
    params: 'Parameters',
    prereqs: 'Before it can run',
    noPrereqs: 'Ready to run — nothing missing.',
    kpiSteps: 'Steps',
    kpiMcp: 'without a model',
    kpiRunCost: 'Model cost per run',
    kpiSynth: 'Synthesis cost',
    kind: { mcp_call: 'MCP', llm: 'Model', ask_human: 'Human', agent: 'Agent', browser: 'Browser' },
    prereq: {
      server_missing: 'Connect the {{name}} integration',
      server_needs_auth: 'Sign in to {{name}} again',
      write_access: 'Allow "{{tool}}" on {{name}} (write access)',
      scope_missing: '{{note}}',
      unsupported_step:
        'Step "{{step}}" needs the browser fallback (not available yet) — connect an integration for this site instead',
    },
    fix: 'Fix',
    suggestTitle: 'Best agent to run this',
    suggestNew: 'No good match? A dedicated agent: {{runtime}} · {{model}}',
    attach: 'Attach',
    attached: 'Attached',
    attachedTo: 'Attached to',
    reason: {
      covers_servers: 'has the integrations ({{detail}})',
      already_attached: 'already attached',
      deterministic: 'runs without a model: no token cost',
      subscription: 'Claude subscription: $0 per token',
      cheap_model: 'cheap model',
      least_privilege: 'no extra integrations',
      role_fit: 'role fits',
      no_tools_model: 'model cannot call tools',
    },
    missing: {
      bind_server: 'gets {{detail}} on attach',
      connect_server: 'connect {{detail}} first',
      egress_host: 'needs {{detail}} on its egress allowlist',
    },
    run: 'Run',
    runTitle: 'Run “{{name}}”',
    runStarted: 'Flow run started',
    notAttached: 'Attach the flow to an agent first.',
    editJson: 'Edit steps (JSON)',
    saveVersion: 'Save as new version',
    changelog: 'What changed?',
    versionSaved: 'New version saved',
    archive: 'Archive',
    source: 'from recording',
    noParams: 'No parameters.',
    defaultValue: 'default',
    required: 'required',
    agentTab: 'Flows',
    agentNone: 'No flows attached. Record a procedure on the Flows page and attach it here.',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    remove: 'Remove',
    add: 'Add',
    close: 'Close',
    confirm: 'Confirm',
    loading: 'Loading…',
    retry: 'Retry',
    search: 'Search',
    all: 'All',
    none: 'None',
    name: 'Name',
    status: 'Status',
    role: 'Role',
    agent: 'Agent',
    model: 'Model',
    provider: 'Provider',
    cost: 'Cost',
    tokens: 'Tokens',
    created: 'Created',
    updated: 'Updated',
    actions: 'Actions',
    yes: 'Yes',
    no: 'No',
    readOnly: 'Read-only: your role cannot change this.',
    approve: 'Approve',
    deny: 'Deny',
    reason: 'Reason (optional)',
    stop: 'Stop',
    send: 'Send',
    today: 'Today',
    from: 'From',
    to: 'To',
    noData: 'Nothing here yet.',
  },
  auth: {
    signIn: 'Sign in',
    email: 'Email',
    password: 'Password',
    remember: 'Keep me signed in for 7 days',
    passkey: 'Sign in with passkey',
    or: 'or',
    twoFactor: 'Two-factor authentication',
    totpPrompt: 'Enter the 6-digit code from your authenticator app.',
    emailCodeLink: 'Lost your authenticator app? E-mail me a code',
    emailCodePrompt:
      'We e-mailed a 6-digit code to the address of your account. It is valid for 15 minutes and works once.',
    emailCode: 'Code from your e-mail',
    emailCodeResend: 'Send a new code',
    useAuthenticator: 'Use authenticator app',
    verify: 'Verify',
    trustDevice: 'Remember this device for 7 days (skip the code)',
    back: 'Back',
    tagline: 'a company of AI agents',
  },
  setup: {
    title: 'First-run setup',
    step1: 'Owner account',
    step2: 'Organization',
    step3: 'Two-factor',
    step4: 'Passkey',
    name: 'Your name',
    orgName: 'Organization name',
    orgSlug: 'Slug',
    passwordHint: 'At least 12 characters.',
    next: 'Continue',
    scanQr: 'Scan this QR code with your authenticator app, then enter the 6-digit code.',
    manualKey: 'Or enter this URI manually',
    backupCodes: 'Backup codes — store these somewhere safe. Each works once.',
    addPasskey: 'Add a passkey',
    skip: 'Skip for now',
    done: 'Open dashboard',
    passkeyHint: 'Passkeys let you sign in with Touch ID, Windows Hello or a security key.',
  },
  pages: {
    company: 'Company',
    companySub: 'Live org chart — status, current task and spend today.',
    agents: 'Agents',
    newAgent: 'New agent',
    chat: 'Chat',
    tasks: 'Tasks',
    runs: 'Runs',
    flows: 'Flows',
    skills: 'Skills',
    approvals: 'Approvals',
    usage: 'Usage',
    notifications: 'Notifications',
    settings: 'Settings',
  },
  agentCopy: {
    action: 'Duplicate',
    title: 'Duplicate {{name}}',
    hint: 'A new agent with the same setup: you approve everything at once here, nothing has to be approved again one by one.',
    submit: 'Create copy',
    takesOver: 'The copy takes over',
    basics: 'Instructions, role, manager, model {{model}} and limits (max {{steps}} steps)',
    tools_one: '{{count}} built-in tool or permission',
    tools_other: '{{count}} built-in tools and permissions',
    integrations_one: '{{count}} integration (MCP)',
    integrations_other: '{{count}} integrations (MCP)',
    hosts_one: '{{count}} allowed network host',
    hosts_other: '{{count}} allowed network hosts',
    rules: '{{count}} tool rules, {{skills}} skills, git settings',
    notCopied: 'Not copied: triggers, memory, workspaces and run history.',
  },
  talk: {
    overview: 'Overview',
    search: 'Search channels, people and messages…',
    messages: 'Messages',
    channels: 'Channels',
    noChannels: 'No channels yet. Agents open them when they need to sort something out.',
    people: 'Agents',
    agentDms: 'Between agents',
    recentChats: 'Your recent chats',
    presence: {
      running: 'working',
      approval: 'waiting for you',
      idle: 'available',
      failed: 'available (last run failed)',
      paused: 'paused',
    },
    markRead: 'Mark as read',
    markUnread: 'Mark as unread',
    replying: 'Someone is replying',
    typing: 'typing…',
    openInChat: 'Open in chat →',
    openRun: 'view run',
    fromRun: 'from a run',
    person: 'person',
    replies_one: '{{count}} reply',
    replies_other: '{{count}} replies',
    replyInThread: 'Reply in thread',
    mention: 'Mention an agent',
    isReplying_one: '{{names}} is replying…',
    isReplying_other: '{{names}} are replying…',
    thread: 'Thread',
    replyPlaceholder: 'Reply in the thread (@slug to mention someone)',
    notFound: 'This channel does not exist (any more).',
    dmHint: 'Private line between two agents. You read along.',
    createdBy: 'created by {{name}}',
    temporary: 'temporary',
    anAgent: 'an agent',
    temporaryHint:
      'Temporary coordination channel opened by {{name}}. It stays open so you can follow what was agreed; close it when the work is done.',
    temporaryClosed: 'This coordination channel is closed. The conversation is kept for reference.',
    closeChannel: 'Close channel',
    dmEmpty: 'These agents have not written to each other yet.',
    dmPlaceholder: 'Write in {{name}} (@slug to reach an agent)',
    sys: {
      created: '{{who}} created this channel',
      createdWith: '{{who}} created this channel with {{others}}',
      added: '{{who}} added {{others}}',
      joined: '{{who}} joined',
      delegated: '{{who}} gave {{to}} a task: {{title}}',
      reported: '{{who}} finished the task: {{text}}',
      reportedFailed: '{{who}} could not finish the task: {{text}}',
      replyFailed: '{{who}} could not reply',
      stopped: {
        agent_turns: 'Paused: agents kept replying to each other. Mention an agent to continue.',
        chain_depth: 'Paused: this conversation reached the chain depth limit.',
        channel_rate: 'Paused: too many replies in this channel this hour.',
      },
    },
  },
  broadcast: {
    open: 'Message several agents',
    tabs: 'Open conversations',
    title: 'Message several agents',
    description: 'Send one message to up to {{max}} agents. Each answer streams in its own pane.',
    agents: 'Agents',
    message: 'Message',
    placeholder: 'What should they all look at? (⌘/Ctrl+Enter to send)',
    send: 'Send to {{count}} agents',
    sent: 'Sent to {{count}} agents',
  },
  chat: {
    waitingSubscription: '{{name}} is waiting for the subscription limit to reset — esc to stop',
    queuePlaceholder: '{{name}} is working — type to queue a message, esc to interrupt',
    inboxQueued: 'Queued',
    inboxDelivered: 'Delivered',
    inboxProcessed: 'Processed',
    pickAgent: 'Agent',
    newConversation: 'New conversation',
    conversations: 'Conversations',
    placeholder: 'Message {{name}}… (Enter to send, Shift+Enter for newline)',
    empty: 'Pick a conversation or start a new one.',
    thinking: 'Thinking',
    reasoning: 'Reasoning',
    awaitingApproval: 'Waiting for approval',
    egressBlocked: 'Network blocked',
    egressHint: "The sandbox egress proxy refused these hosts (not on the agent's allowlist).",
    egressAllow: 'Allow for this agent',
    egressAllowed: 'allowed',
    egressGranted: '{{host}} added to the network allowlist of {{name}}',
    fallbackTitle: '{{from}} → {{to}}',
    fallbackUsageLimit: 'The {{from}} subscription reached its usage limit. The run continues on {{to}}.',
    fallbackRecovered: 'The preferred subscription is available again: from {{from}} to {{to}}.',
    fallbackCoolingDown:
      'The {{from}} subscription is cooling down after a usage limit. The run continues on {{to}}.',
    fallbackActiveModel: 'Active model: {{model}}',
    activeModel: 'Active model',
    configuredModel: 'configured: {{model}}',
    effort: 'effort {{level}}',
    fallbackBadge: 'fallback',
    fallbackToCodexTip: 'Claude limit reached, now answering via Codex',
    fallbackToClaudeTip: 'Codex limit reached, now answering via Claude',
    approvalTitle: 'Approval required',
    asksApproval: 'asks for approval',
    delegatedTo: 'Handed over to ',
    delegatedResume: 'continues as soon as the result is in.',
    stopped: 'Stopped',
    reconnecting: 'Reconnecting…',
  },
  runStatus: {
    queued: 'queued',
    running: 'running',
    scheduled: 'scheduled',
    awaiting_approval: 'awaiting approval',
    awaiting_human: 'awaiting human',
    waiting_children: 'waiting children',
    completed: 'completed',
    failed: 'failed',
    cancelled: 'cancelled',
  },
  runs: {
    tabActive: 'Active',
    tabAttention: 'Needs you',
    tabFailed: 'Failed',
    tabAll: 'All',
    stopAll: 'Stop all active ({{count}})',
    stopSelected: 'Stop selected',
    selected: '{{count}} selected',
    clearSelection: 'Clear',
    confirmTitle: 'Stop {{count}} run(s)?',
    confirmBody:
      'Running work is cancelled; finished steps and results are kept. Tasks and waiting parents are updated for you.',
    confirmStop: 'Stop {{count}} run(s)',
    andMore: '…and {{count}} more',
    stopped: '{{count}} stopped, {{done}} had already finished',
    stopFailed: '{{count}} could not be stopped',
    downloadLogs: 'Download logs',
    downloadLogsHint: 'Download redacted log and status events for this run',
    scheduledReason: {
      usage_limit: 'Usage limit reached',
      plan_limit: 'Monthly runs of your plan used up',
      auth_required: 'Waiting for a new Claude sign-in',
    },
    loginRequiredHint:
      'Anthropic no longer accepts the Claude account this agent runs on. Progress is saved; the run continues as soon as its owner lets Claude Code sign in again (Settings › Providers).',
    provider: { claude: 'Claude', codex: 'Codex' },
    scheduledNote: '{{reason}}{{provider}} · resumes {{when}} ({{rel}})',
    planLimitHint:
      'New runs wait until your next billing period. Upgrade your plan and choose Continue to start it now.',
    subscriptionUnavailable:
      'No subscription fallback is available. Progress is saved; this run will retry automatically.',
    scheduledNoteAttempt: 'automatic resumption {{n}}',
    scheduledHint:
      'The run is paused with its progress saved. It continues by itself when the limit resets; finished steps are not repeated.',
    failedLimitTitle: 'Stopped: usage limit reached again',
    failedLimitHint:
      'The automatic resumptions are used up. The saved progress is kept — "Continue" picks up where it stopped, without repeating finished steps.',
    continue: 'Continue',
    continueTitle: 'Continue now from the saved progress instead of waiting for the reset',
    continued: 'Run continues',
    restart: 'Restart',
    restartTitle: 'Start a new run with the same agent and input (this run stays as it is)',
    restarted: 'New run started',
    restartedFrom: 'restarted from {{id}}',
    allStatuses: 'All statuses',
    allAgents: 'All agents',
    count: '{{count}} runs',
    statusFilter: 'Status filter',
    agentFilter: 'Agent filter',
  },
  approvals: {
    humanAccess: 'Extra access — human approval',
    accessExecuted: 'Access request executed (changed/total)',
    needsYou: '{{count}} waiting for you',
    allCaughtUp: 'All caught up',
    emptyHint:
      'When an agent needs a decision, an answer or network access, it shows up here and you get a notification.',
    statApprovals: 'Approvals',
    statQuestions: 'Questions',
    statNetwork: 'Network requests',
    pending: 'Pending',
    decided: 'Decided',
    expires: 'expires {{when}}',
    decideTitle: '{{action}} {{tool}}',
    questions: 'Questions from agents',
    questionFrom: '{{agent}} asks a question',
    questionWaiting: 'The agent is waiting for your answer',
    answered: 'Answered',
    answeredBy: 'answered by {{who}} {{when}}',
  },
  notifications: {
    markRead: 'Mark read',
    markAllRead: 'Mark all read',
    unread: 'Unread',
  },
  help: {
    title: 'Help Center',
    subtitle: 'Tutorials, guides and answers about Mandistry.',
    searchPlaceholder: 'Search the Help Center or ask a question…',
    ask: 'Ask AI',
    asking: 'Answering…',
    answerTitle: 'Summary',
    sources: 'Sources',
    readMore: 'Read more',
    usedArticles: 'Articles used ({{count}})',
    moreArticles: 'More articles ({{count}})',
    noResults: 'No articles found. Try other words, or ask the assistant.',
    results: 'Articles',
    browse: 'Browse by topic',
    tutorials: 'Tutorials',
    tutorialsHint: 'Step-by-step guides, from first agent to recorded flows.',
    popularTutorials: 'Start with a tutorial',
    otherArticles: 'More articles',
    articleCount_one: '{{count}} article',
    articleCount_other: '{{count}} articles',
    categoryNotFound: 'This topic does not exist (anymore).',
    typePlural: { tutorial: 'Tutorials', article: 'Articles', faq: 'Frequently asked' },
    all: 'All articles',
    back: 'Help Center',
    otherLanguage: 'This article is not available in your language yet.',
    helpful: 'Was this helpful?',
    yes: 'Yes',
    no: 'No',
    thanks: 'Thanks for your feedback.',
    related: 'Related articles',
    notFound: 'This article does not exist or is no longer available.',
    updated: 'Updated {{date}}',
    aiNoKey: 'AI answers are not available right now. Here are the matching articles.',
    aiLimit: 'You have reached the hourly limit for AI answers. Here are the matching articles.',
    aiBudget: 'AI answers are paused for today. Here are the matching articles.',
    aiError: 'The assistant could not answer. Here are the matching articles.',
    cached: 'Saved answer',
    chatTitle: 'Help assistant',
    chatHint: 'Ask how something works. Answers come from the Help Center.',
    chatPlaceholder: 'Ask a question…',
    chatError: 'The answer could not be completed. Please try again.',
    incomplete: 'This answer is incomplete. Try again to request a new answer.',
    chatRetry: 'Try again',
    chatSend: 'Send',
    chatOpen: 'Open the help assistant',
    chatClose: 'Close',
    chatNew: 'New conversation',
    chatFull: 'Open full page',
    chatDisclaimer: 'This conversation is saved to improve the Help Center. AI can make mistakes.',
    type: { article: 'Article', tutorial: 'Tutorial', faq: 'FAQ' },
  },
  settings: {
    providers: 'Providers',
    models: 'Models & prices',
    budgets: 'Budgets',
    members: 'Members & roles',
    security: 'Security',
    audit: 'Audit log',
    channels: 'Notification channels',
    integrations: 'Integrations (MCP)',
    mcp: 'Claude Code (MCP)',
    knowledge: 'Knowledge & Obsidian',
    company: 'Company',
  },
  company: {
    tabs: 'Company views',
    tab: { live: 'Live', org: 'Org chart' },
    filterStatus: 'Filter by status',
    legendRunning: 'running',
    legendApproval: 'awaiting approval',
    legendIdle: 'idle',
    legendPaused: 'paused',
    activeLines: '{{count}} active reporting lines',
    tapHint: 'tap an agent to open it',
    clickHint: 'click an agent to open it',
    permissions: 'Permissions',
    manageCompany: 'Manage the company',
    manageCompanyHint:
      'Lets this agent create, edit and archive the agents below it (e.g. a CEO building out the company). Each change asks a human for approval unless a policy rule says otherwise. It can only pass on tools, integrations and limits it has itself, and never this permission.',
    manageTriggers: 'Manage triggers',
    manageTriggersHint:
      'Lets this agent manage triggers for its reports with current permission checks. Every persistent agent can manage its own cron/interval schedules. Direct user scheduling requests use default policy without extra approval; explicit rules and untrusted-input guards still apply. Event changes and deletion retain approval policy. Agent-made triggers fire at most 12 times per hour. Only a human can grant manager permission.',
    unlocks: 'Unlocks: {{tools}}',
    settingsIntro:
      'Agents with the "Manage the company" permission can build out the company themselves: create, edit and archive agents below them. Only a human can grant it. Changes are approved by a human by default (see Approvals) and are always audited.',
    holders: 'Who can manage the company',
    noHolders: 'No agent has this permission yet.',
    grant: 'Allow {{name}} to manage the company',
    granted: '{{name}} can now manage the company',
    revoked: '{{name}} can no longer manage the company',
    needsAdmin: 'Only admins can change this permission.',
  },
  permissionsPanel: {
    previewSummary: '{{count}} known actions may prompt you.',
    previewIncomplete: '{{count}} integrations still need checking.',
    previewAlwaysReviewed:
      'Destructive actions, payments, missing access and explicit ask rules remain separately reviewed.',
    possiblePrompts: 'Possible prompts ({{count}})',
    automatic: 'Automatic',
    asksPermission: 'Asks permission',
    blocked: 'Blocked',
    dependsOnTheAction: 'Depends on the action',
    unavailableThroughThisBindingOr:
      'Unavailable through this binding or server setting. Configure access under Integrations.',
    humanApprovalRequiredIncludingIn: 'Human approval required, including in Auto.',
    extraCapabilitiesRequireApprovalLocal:
      'Extra capabilities require approval. Local files and commands are checked per action.',
    explicitAgentOrCompanyRule: 'Explicit agent or company rule; takes precedence over Auto.',
    defaultForThisToolAnd: 'Default for this tool and execution mode.',
    aClarificationPausesWorkAuto:
      'A clarification pauses work. Auto uses reasonable assumptions where possible.',
    summary:
      '{{allow}} actions run automatically · {{ask}} may ask permission · {{deny}} are blocked · {{rules}} custom rules',
    whereMightThisAgentAsk: 'Where might this agent ask for permission?',
    checkBeforeStartingWorkThis:
      'Check before starting work. This overview uses your current draft and the same rules as execution.',
    execution: 'Execution',
    standard: 'Standard',
    networkLimitsAndPlanReview: 'Network, limits and plan review',
    configureIntegrations: 'Configure integrations',
    accessApprovedInAdvance: 'Access approved in advance',
    sandboxNetworkHosts: 'Sandbox network hosts',
    noneNewHostsRequireApproval: 'None; new hosts require approval.',
    directPushesToBranches: 'Direct pushes to branches',
    noneChangesGoThroughPull: 'None; changes go through pull/merge requests.',
    checkingPermissions: 'Checking permissions…',
    planReviewIsEnabledA: 'Plan review is enabled. A plan may wait for approval before execution.',
    accessByAction: 'Access by action',
    searchActions: 'Search actions',
    searchAToolOrIntegration: 'Search a tool or integration…',
    action: 'Action',
    configure: 'Configure',
    rule: 'Rule',
    configureAccess: 'Configure access',
    toolSettings: 'Tool settings',
    required: 'Required',
    ruleFor: 'Rule for',
    defaultInherit: 'Default / inherit',
    allowAutomatically: 'Allow automatically',
    alwaysAsk: 'Always ask',
    block: 'Block',
    noActionsMatchThisFilter: 'No actions match this filter.',
    connectedIntegrations: 'Connected integrations',
    toolListKnown: 'Tool list known',
    discoverToolsInMcpFirst: 'Discover tools in MCP first',
    reconnect: 'Reconnect',
    disabled: 'Disabled',
    readOnlyByDefaultIndividual: 'Read only by default; individual exceptions may be configured.',
    integrationsUseTheLastDiscovered:
      'Integrations use the last discovered tool list. Network access, server permissions and targets are checked again during execution. Attachments and follow-up work can expose additional actions. Saving activates changes for new runs; active runs keep their version.',
  },
  bulkPermissions: {
    copyFrom: 'Copy selected draft permissions from {{name}}.',
    saveFor: 'Save for {{count}} agents',
    executionStandardAuto: 'Execution (Standard / Auto)',
    replaceToolRules: 'Replace tool rules',
    replaceEnabledPlatformTools: 'Replace enabled platform tools',
    replaceAllowedNetworkHosts: 'Replace allowed network hosts',
    replaceDirectPushBranches: 'Replace direct push branches',
    permissionsSavedForSelectedAgents: 'Permissions saved for selected agents',
    applyToMultipleAgents: 'Apply to multiple agents',
    changeGroupPermissions: 'Change group permissions',
    checkedSettingsWillBeReplaced:
      'Checked settings will be replaced. Each agent gets a new active version. Instructions, models and other settings are preserved. Active runs retain their version. The group is selected by role; future agents are not updated automatically.',
    whichSettings: 'Which settings?',
    viewNewValues: 'View new values',
    whichAgents: 'Which agents?',
    roleType: 'Role / type',
    allRoles: 'All roles',
    searchAgents: 'Search agents',
    searchEGDeveloper: 'Search e.g. developer…',
    selectVisibleAgents: 'Select visible agents',
    clearSelection: 'Clear selection',
    noAgentsFound: 'No agents found.',
    selected: 'Selected',
  },
};

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };
export type Resources = Shape<typeof en>;
